var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtPsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_131",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E86046"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 18C21.9111 18 22.3889 17.8111 22.7667 17.4333C23.1444 17.0556 23.3333 16.5778 23.3333 16C23.3333 15.4222 23.1444 14.9444 22.7667 14.5667C22.3889 14.1889 21.9111 14 21.3333 14C20.7556 14 20.2778 14.1889 19.9 14.5667C19.5222 14.9444 19.3333 15.4222 19.3333 16C19.3333 16.5778 19.5222 17.0556 19.9 17.4333C20.2778 17.8111 20.7556 18 21.3333 18ZM6.66667 28C5.93333 28 5.30556 27.7389 4.78333 27.2167C4.26111 26.6944 4 26.0667 4 25.3333V6.66667C4 5.93333 4.26111 5.30556 4.78333 4.78333C5.30556 4.26111 5.93333 4 6.66667 4H25.3333C26.0667 4 26.6944 4.26111 27.2167 4.78333C27.7389 5.30556 28 5.93333 28 6.66667V10H25.3333V6.66667H6.66667V25.3333H25.3333V22H28V25.3333C28 26.0667 27.7389 26.6944 27.2167 27.2167C26.6944 27.7389 26.0667 28 25.3333 28H6.66667ZM17.3333 22.6667C16.6 22.6667 15.9722 22.4056 15.45 21.8833C14.9278 21.3611 14.6667 20.7333 14.6667 20V12C14.6667 11.2667 14.9278 10.6389 15.45 10.1167C15.9722 9.59444 16.6 9.33333 17.3333 9.33333H26.6667C27.4 9.33333 28.0278 9.59444 28.55 10.1167C29.0722 10.6389 29.3333 11.2667 29.3333 12V20C29.3333 20.7333 29.0722 21.3611 28.55 21.8833C28.0278 22.4056 27.4 22.6667 26.6667 22.6667H17.3333ZM26.6667 20V12H17.3333V20H26.6667Z",
    fill: "#FB2648"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtPsIcon);
export default __webpack_public_path__ + "static/media/et-ps-icon.03321bcc2f93fc4162b23edcd4914891.svg";
export { ForwardRef as ReactComponent };